<template>
  <BaseCardV2
    v-if="!loading"
    :chip="{libelle: 'Gestion déléguée'}"
    :has-btn-action="false"
    has-help
    :titre="libelleGraphe" 
    @on-help="isOpenModalHelp = true"
  >
    <BaseLoader v-if="loading" />
    
    <BaseComparaisonLegende
      v-if="!loading"
      :donnee-groupe="Object.values(evolutionPrixContratGestionDeleguee.primeSeptAvrilParAnnee).length || Object.values(evolutionPrixContratGestionDeleguee.primeQuintoParAnnee).length ? {libelle:libelleContratSeptembreAvrilOuQuinto} : null"
      :donnee-perso="Object.values(evolutionPrixContratGestionDeleguee.primePrixCampagneParAnnee).length ? {libelle:'Prix de campagne'} : null"
      :couleur-primaire="datasetPrixContratPrixCampagne.borderColor"
      :couleur-secondaire="datasetPrixContratSeptembreAvril.borderColor"
      class="ml-3 my-5"
    />
    <div :class="$vuetify.breakpoint.mobile ? '' : 'h-500'">
      <BaseComparaisonLineChart
        v-if="!loading"
        :id="chartData.id"
        :chart-data="chartData"
        class="mt-5 mb-2 pr-3"
        ordonnee="€/t"
        :tooltip-label-groupe="libelleContratSeptembreAvrilOuQuinto + ' :'"
        tooltip-label-perso="Prix de campagne : "
        unite="€/t"
        :is-maintain-aspect-ratio="$vuetify.breakpoint.mobile"
      />
    </div>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="évolution des prix de contrat"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8 background-color-white">
          <p>
            Retrouvez l'historique des prix de contrats en gestion déléguée, prime d'engagement incluse. Pour bénéficier de la prime d'engagement, votre engagement doit respecter les périodes suivantes :
          </p>
          <div class="table-scroll mt-5">
            <table>
              <thead>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Contrat
                  </th>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold">
                    Prix de campagne engagé
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Graines
                  </th>
                  <td class="text-body-2 text-grey-darken-1 text-left">
                    Avoine / blé tendre / blé dur / colza durable / colza érudique / féverole / maïs / millet / orge fourragère / orge
                    de brasserie / pois jaune / sorgho / soja / tournesol classique / tournesol oléique / triticale
                  </td>
                </tr>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Période d'engagement
                  </th>
                  <td class="text-body-2 text-grey-darken-1 text-left">
                    <div>Avant le 15/01/N</div>
                    <div>(Produits semés à l'automne)</div>
                    <div>Avant le 31/05/N</div>
                    <div>(Produits semés au printemps)</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Contrat
                  </th>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold">
                    Septembre - avril
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Graine
                  </th>
                  <td class="text-body-2 text-grey-darken-1 text-left">
                    Blé tendre / colza durable / féverole / orge fourragère / orge de brasserie / pois / triticale
                  </td>
                </tr>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Période d'engagement
                  </th>
                  <td class="text-body-2 text-grey-darken-1 text-left">
                    Avant le 31/08/N
                  </td>
                </tr>
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Contrat
                  </th>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold">
                    Novembre - Mai
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Graines
                  </th>
                  <td class="text-body-2 text-grey-darken-1 text-left">
                    Tournesol classique / tournesol oléique
                  </td>
                </tr>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Période d'engagement
                  </th>
                  <td class="text-body-2 text-grey-darken-1 text-left">
                    Avant le 31/10/N
                  </td>
                </tr>
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Contrat
                  </th>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold">
                    Quinto
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Graines
                  </th>
                  <td class="text-body-2 text-grey-darken-1 text-left">
                    Maïs
                  </td>
                </tr>
                <tr>
                  <th class="text-body-2 text-grey-darken-2 font-weight-bold text-left w-150">
                    Période d'engagement
                  </th>
                  <td class="text-body-2 text-grey-darken-1 text-left">
                    Avant le 30/11/N
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </HelpModal>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseComparaisonLineChart from '@/components/chart/base-comparaison-line-chart.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseComparaisonLegende from '@/components/chart/base-comparaison-legende.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import { mapGetters } from 'vuex'
import { lowerCase } from 'lodash'
import { getYear, subYears, isBefore, parse } from 'date-fns'
import colorsService from '@/service/colors.service'
import stringFilter from '@/filters/string.filter'

export default {
  name: 'EvolutionPrixContratPrixGestionDeleguee',
  components: { HelpModal, BaseCardV2, BaseComparaisonLineChart, BaseLoader, BaseComparaisonLegende },
  props: {
    loading: {
      type: Boolean,
      default: null
    },
    erreur: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false
    }
  },
  computed: {
    ...mapGetters({
      evolutionPrixContratGestionDeleguee: 'prix/evolutionPrixContratGestionDeleguee',
      anneeRecolteActive: 'application/anneeRecolteActive',
    }),
    libelleGraphe () {
      return 'évolution des prix de contrat ' + stringFilter.prepositionApostrophe(lowerCase(this.evolutionPrixContratGestionDeleguee.varieteCereale.libelle), 'd')
    },
    datasetPrixContratPrixCampagne () {
      let data = []
      this.annees.forEach(annee => {
        if (this.evolutionPrixContratGestionDeleguee.primePrixCampagneParAnnee[annee] != null) {
          data.push(this.evolutionPrixContratGestionDeleguee.primePrixCampagneParAnnee[annee])
        } else {
          data.push(null)
        }
      })
      return {
        type: 'line',
        label: 'Prix de campagne',
        fill: false,
        tension: 0.3,
        segment: {
          borderDash: ctx => this.skippedPrixCampagne(ctx, [8, 6]),
        },
        isPrixProvisoire :this.isPrixProvisoire,
        borderColor: colorsService.barChart.grapheCompositionQualite.prixCampagne,
        backgroundColor: colorsService.barChart.grapheCompositionQualite.prixCampagne,
        data: data
      }
    },
    datasetPrixContratSeptembreAvril () {
      let data = []
      this.annees.forEach(annee => {
        if (this.evolutionPrixContratGestionDeleguee.primeSeptAvrilParAnnee[annee] != null) {
          data.push(this.evolutionPrixContratGestionDeleguee.primeSeptAvrilParAnnee[annee])
        } else {
          data.push(null)
        }
      })
      return {
        type: 'line',
        label: this.evolutionPrixContratGestionDeleguee.novembreMai ? 'Novembre-Mai' : 'Septembre-Avril',
        fill: false,
        tension: 0.3,
        segment: {
          borderDash: ctx => this.skippedSeptembreAvril(ctx, [8, 6]),
        },
        isPrixProvisoire :this.isPrixProvisoire,
        borderColor: colorsService.barChart.grapheCompositionQualite.perso,
        backgroundColor: colorsService.barChart.grapheCompositionQualite.perso,
        data: data
      }
    },
    datasetPrixContratQuinto () {
      let data = []
      this.annees.forEach(annee => {
        if (this.evolutionPrixContratGestionDeleguee.primeQuintoParAnnee[annee] != null) {
          data.push(this.evolutionPrixContratGestionDeleguee.primeQuintoParAnnee[annee])
        } else {
          data.push(null)
        }
      })
      return {
        type: 'line',
        label: 'Quinto',
        fill: false,
        tension: 0.3,
        segment: {
          borderDash: ctx => this.skippedQuinto(ctx, [8, 6]),
        },
        isPrixProvisoire :this.isPrixProvisoire,
        borderColor: colorsService.barChart.grapheCompositionQualite.perso,
        backgroundColor: colorsService.barChart.grapheCompositionQualite.perso,
        data: data
      }
    },
    datasets () {
      let result = []
      if (Object.values(this.evolutionPrixContratGestionDeleguee.primePrixCampagneParAnnee).length) {
        result.push(this.datasetPrixContratPrixCampagne)
      }
      if (Object.values(this.evolutionPrixContratGestionDeleguee.primeSeptAvrilParAnnee).length) {
        result.push(this.datasetPrixContratSeptembreAvril)
      }
      if (Object.values(this.evolutionPrixContratGestionDeleguee.primeQuintoParAnnee).length) {
        result.push(this.datasetPrixContratQuinto)
      }
      return result
    },
    annees () {
      let result = []
      for (let i = 0; i < 4; i++) {
        result.push(getYear(subYears(new Date(this.anneeRecolteActive),i)))
      }
      return result.reverse()
    },
    chartData () {
      return {
        title: '',
        labels: this.annees,
        datasets: this.datasets,
        unite: '€',
        id: 'chartEvolutionPrixGestionDeleguee'
      }
    },
    libelleContratSeptembreAvrilOuQuinto () {
      return Object.values(this.evolutionPrixContratGestionDeleguee.primeSeptAvrilParAnnee).length ? this.evolutionPrixContratGestionDeleguee.novembreMai ? 'Novembre-Mai' : 'Septembre-Avril' : 'Quinto'
    },
    isPrixProvisoire () {
      const anneeRecolte = Number(this.anneeRecolteActive) + 1
      const formatDateLimite = anneeRecolte + '-07-01'
      const dateLimite = parse(formatDateLimite, 'yyyy-MM-dd', new Date())
      return isBefore(new Date(), dateLimite)
    },
  },
  methods: {
    skippedPrixCampagne (ctx, value) {
      return ctx.p1DataIndex === 3 && this.isPrixProvisoire ? value: undefined
    },
    skippedSeptembreAvril (ctx, value) {
      return ctx.p1DataIndex === 3 && this.isPrixProvisoire ? value: undefined
    },
    skippedQuinto (ctx, value) {
      return ctx.p1DataIndex === 3 && this.isPrixProvisoire ? value: undefined
    }
  }
} 
</script>
<style lang="scss" scoped>
.h-500 {
  height: 340px;
}
.table-scroll {
  position: relative;
  width: 100%;
  height: 670px;
  z-index: 1;
  margin: auto;
  overflow: auto;
}

.table-scroll table {
  width: 100%;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 5px;
}

.table-wrap {
  position: relative;
}

.table-scroll th,
.table-scroll td {
  padding: 5px 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  vertical-align: top;
}

.table-scroll thead th {
  background: var(--v-primary);
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: var(--branche-light);
}

th:first-child {
  background: #ccc;
}

.w-150 {
  width: 150px;
}
.background-color-white {
  background-color: white;
}
</style>